import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";
import logo from '../../assets/fonts/jc-logo.png';
import numeral from "numeral";

const styles = StyleSheet.create({
  body: {
    paddingTop: 65,
    paddingBottom: 65,
    paddingHorizontal: 20,
    fontFamily:'Helvetica',
  },
  brbr:{
  	marginBottom:'20',
  },
  upup:{
    marginTop:'20',
    fontSize:'15',
  },
  box: {
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginTop:'45',
  },
  pLeftPart: {
    	minWidth:'40%',
  },
  pRightPart: {
    	minWidth:'40%',
  },
  leftPart: {
    minWidth:'50%',
    maxWidth:'50%',
  },
  rightPart: {
    minWidth:'50%',
    maxWidth:'50%',
    marginLeft:'20',
  },
  tblTitle : {
    fontSize:'9',
    marginBottom: '15',
    fontFamily:'Helvetica-Bold',
  },
  itemTitle : {
    fontSize:'9',
    marginTop: '25',
  },
  
  tableItems:{
      display:'flex',
      flexDirection: 'row',   
      borderBottom: '1',
      marginBottom: '4',
  },
  header1: {
    	minWidth:'85%',
        fontSize: '16',
  },header2: {
    	minWidth:'15%',
        fontSize: '16',
  },
  item1: {
    	minWidth:'85%',
        maxWidth:'85%',
        fontSize: '7',
  },
  item2: {
        fontSize: '7',
  },
  rightAlign:{
    minWidth:'100%',
    paddingRight:'50',
    alignItems:'flex-end',
  },
  paymentInfo: {
        display: 'flex',
        flexDirection: 'row',
      	justifyContent:'flex-start',
    	marginBottom: '5',
  },

  	cvItems:{
      marginTop: '7',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start'
    },
  
	cvTableHeader:{
      marginTop: 15,
      display:'flex',
      flexDirection: 'row',
      borderBottom:'1 solid black',
      justifyContent:'flex-start'
    },
    
    cvTblHeader1:{
        fontSize: 8,
        minWidth:'35%',
        maxWidth:'35%',
    },
    cvTblHeader1Bold:{
      fontSize: 8,
      minWidth:'35%',
      maxWidth:'35%',
          fontFamily:'Helvetica-Bold',
  },
    cvTblHeader2:{
        fontSize: 8,
        minWidth:'20%',
        maxWidth:'20%',
        textAlign:'right',
    },
    cvTblHeader2Bold:{
      fontSize: 8,
      minWidth:'20%',
      maxWidth:'20%',
      textAlign:'right',
          fontFamily:'Helvetica-Bold',
  },
    cvTblHeader3:{
        fontSize: 8,
        minWidth:'20%',
        maxWidth:'20%',
        textAlign:'right',
    },
    cvTblHeader3Bold:{
      fontSize: 8,
      minWidth:'20%',
      maxWidth:'20%',
      textAlign:'right',
          fontFamily:'Helvetica-Bold',
  },
    cvTblHeader4:{
        fontSize: 8,
        minWidth:'25%',
        maxWidth:'25%',
        textAlign:'right',
    },
    cvTblHeader4Bold:{
      fontSize: 8,
      minWidth:'25%',
      maxWidth:'25%',
      textAlign:'right',
          fontFamily:'Helvetica-Bold',
  },
      cvTblHeader5:{
        fontSize: 8,
        minWidth:'65%',
        maxWidth:'70%',
        textAlign:'right',
    },
    cvTblHeader5Bold:{
      fontSize: 8,
      minWidth:'65%',
      maxWidth:'70%',
      textAlign:'right',
          fontFamily:'Helvetica-Bold',
  },
      cvTblHeader6:{
        fontSize: 8,
        minWidth:'35%',
        maxWidth:'35%',
        textAlign:'right',
    },
    cvTblHeader6Bold:{
      fontSize: 8,
      minWidth:'35%',
      maxWidth:'35%',
      textAlign:'right',
          fontFamily:'Helvetica-Bold',
  },
  
  
  
  innerBox: {
      fontSize:'8',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginBottom: '5',
  },
  innerLeftPart: {
    	minWidth:'50%',
      	maxWidth:'30%',
        alignItems:'flex-start',
  },
  innerRightPart: {
    	minWidth:'40%',
      alignItems:'flex-end',
  },
  innerLeftPayment: {
    	minWidth:'60%',
      	maxWidth:'60%',
        alignItems:'flex-start',
  },
  approvedBy: {
    	minWidth:'40%',
        alignItems:'flex-start',
      	borderTop: '1',
        marginTop: '50'
  },
  approver:{
    fontSize:'8',
    textAlign:'left',
},
  nestedItem1:{
    paddingLeft:'30'
  },
  nestedItem2:{
    paddingLeft:'51'
  },
  nestedItem2:{
    paddingLeft:'42'
  },
  nestedItem3:{
    paddingLeft:'51'
  },
  right:{
    alignSelf:'flex-end',
    fontSize: '8',
  },
  boldRight:{
    alignSelf:'flex-end',
    fontSize: '8',
    fontFamily:'Helvetica-Bold',
  },
  wrap:{
     marginBottom: '5',
  }, 
  mRight:{
     paddingLeft:'25',
  },
  title: {
    fontSize: '11',
    textAlign: 'center',
    fontFamily:'Helvetica-Bold',
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: '40',
  },
  subtitle: {
    fontSize: '18',
    margin: '12',
    fontFamily: 'Oswald',
  },
  text: {
    margin: '12',
    fontSize: '7',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  image: {
    position: 'absolute',
    width:'40px',
    height:'40px',
    left:19,
    top:45,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 9,
    bottom: 30,
    left: -500,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  totalTextBold:{
    fontSize:'8',
    // paddingLeft:'10',
    fontFamily:'Helvetica-Bold',
  },
  bold:{
    fontFamily:'Helvetica-Bold',
  }
});

  export function JcPortalSalesOrder(props) {
    const {soInfo, items, sono} = props;
      return (
        <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.title}>JC PORTAL SALES ORDER</Text>
          <Image
            style={styles.image}
            src={logo}
          />
            <View style={styles.box}>
              <View style={styles.leftPart}>
                <Text style={styles.tblTitle}>Order Information</Text>
                  <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>ID NO</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.idno_to_load}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Type</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.trans_type}</Text></View>
                   </View>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>SO Number</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.sono}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Date</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.transdate}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text style={styles.nestedItem1}>Package Amount</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.total_amount}</Text></View>
                   </View>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text style={styles.nestedItem2}>B1T1 Discount</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.b1t1_discount}</Text></View>
                   </View>
                  <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text style={styles.nestedItem3}>Shipping Fee</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.freight).format('0,0.00')}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Grand Total</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.boldRight}>{numeral(soInfo.grand_total).format('0,0.00')}</Text></View>
                   </View>
               </View>
              
              <View style={styles.rightPart}>
                   <Text style={styles.tblTitle}>Delivery Details</Text>
                    <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.shipped_to}</Text></View>
                     </View>
                            <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.td_phonenumber}</Text></View>
                     </View>
                        <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.email}</Text></View>
                     </View>
                       <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.delivered_to}</Text></View>
                     </View>
                
                	<View style={styles.brbr}></View>
                
                    <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text style={styles.bold}>Shipping Status</Text></View>
                            <View style={styles.innerRightPart}><Text style={styles.mRight}>{soInfo.isdelivered}</Text></View>
                     </View>
                     <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text style={styles.bold}>Waybill No</Text></View>
                            <View style={styles.innerRightPart}><Text style={styles.mRight}>{soInfo.waybill_no}</Text></View>
                     </View>
               </View>
             </View>
          
      	 <View style={styles.upup}>
            <Text style={styles.tblTitle}>Item Details</Text>
         </View>
         <View style={styles.cvTableHeader}>
            <Text style={styles.cvTblHeader1Bold}>Item</Text>
            <Text style={styles.cvTblHeader2Bold}>Price</Text>
            <Text style={styles.cvTblHeader3Bold}>Qty</Text>
            <Text style={styles.cvTblHeader4Bold}>Subtotal</Text>
         </View> 
          
          {items.map((item=>{
            return(
              <View style={styles.cvItems}>
                <Text style={styles.cvTblHeader1}>{item.item_name}</Text>
                <Text style={styles.cvTblHeader2}>{item.price}</Text>
                <Text style={styles.cvTblHeader3}>{item.qty}</Text>
                <Text style={styles.cvTblHeader4}>{item.total}</Text>
              </View> 
            )
          }))}   
          
        <View style={styles.cvItems}>
            <Text style={styles.cvTblHeader5}>Subtotal</Text>
            <Text style={styles.cvTblHeader6}>{soInfo.total_amount}</Text>
        </View>
          
 		    <View style={styles.box}>
              <View style={styles.pLeftPart}>
                <Text style={styles.tblTitle}>Payment Information</Text>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPayment}>
                        	<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>Payment Status</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{soInfo.ispaid}</Text>
                              </View>
                        	</View>
                        
                          {soInfo.cp_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>CP Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.cp_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}

                          {soInfo.b1t1_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>B1T1 Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.b1t1_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}

                          {soInfo.ppv_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>PPV Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.ppv_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}
                        
                          {soInfo.dragonpay_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>Dragonpay Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.dragonpay_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}

                          {soInfo.paypanda_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>Paypanda Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.paypanda_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}

                          {soInfo.asiapay_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>Asiapay Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.asiapay_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}

                          {soInfo.ipay_payments > 0 ?(<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>Ipay Payments</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text>{numeral(soInfo.ipay_payments).format('0,0.00')}</Text>
                              </View>
                        	</View>) :(<></>)}

                             <View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart}>
                                   <Text>Total</Text>
                                </View>
                              <View style={styles.innerRightPart}>
                                <Text style={styles.totalTextBold}>{numeral(soInfo.grand_total).format('0,0.00')}</Text>
                              </View>
                        	</View>
                      </View>
                     
                       <View style={styles.approvedBy}><Text style={styles.approver}>Approved By</Text></View>
                   </View>
          	  </View>
        </View>
          

          
         <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `Page ${pageNumber} / ${totalPages}`
      )} fixed />
        </Page>
      </Document>
       );
  }; 
   